export default "__VITE_ASSET__BmsHtozO__"